$(document).ready(function() {
  $.each($('.switch-send-as-gift'), function(key, element) {
    $(element).click(function() {
      var $this         = $(this);
      var id            = $this.data('id');
      var parentElement = $this.closest('.parentSendAsGift');
      if ($this.is(':checked')) {
        parentElement.find('.gift').removeClass('d-none');
      } else {
        parentElement.find('.gift').addClass('d-none');
      }

      giftRecipientName(id)
      giftRecipientEmail(id)
      giftRecipientRemark(id)
    })
  })

  function giftRecipientName(id) {
    $(`#buttonRecipientName-${id}`).click(function() {
      var val = $(`#formRecipientName-${id}`).val();
      recipientName(val, id);
      closeAllPopup();
    })
  }

  function giftRecipientEmail(id) {
    $(`#buttonRecipientEmail-${id}`).click(function() {
      var val = $(`#formRecipientEmail-${id}`).val();
      recipientEmail(val, id);
      closeAllPopup();
    })
  }

  function giftRecipientRemark(id) {
    $(`#buttonRecipientNote-${id}`).click(function() {
      var val = $(`#formRecipientNote-${id}`).val();
      recipientNote(val, id);
      closeAllPopup();
    })
  }

  function recipientEmail(emailUser, id) {
    var bodyRecipientEmail = `<i class="ri-mail-line text-neutral-80 fs-24"></i>`+
                              `<div class="d-flex flex-column ms-12">`+
                                `<span class="text-dark fs-12 fw-600 lh-16">Recipient Mail</span>`+
                                `<span class="text-dark fs-14 lh-20">${emailUser}</span>`+
                                `<input type="hidden" class="hiddenRecipientEmail-${id}" value="${emailUser}" name="gift[${id}]recipient_email">`+
                              `</div>`+
                              `<div class="d-flex align-items-center text-info ms-auto">`+
                                `<span class="fs-12 fw-600">Edit</span>`+
                                `<i class="ri-arrow-right-s-line fs-18 "></i>`+
                              `</div>`;

    $(`.recipientEmail-${id}`).html(bodyRecipientEmail);
    $(`.hiddenRecipientEmail-${id}`).val(emailUser);
  }

  function recipientName(nameUser, id) {
    var bodyrecipientName = `<i class="ri-user-line text-neutral-80 fs-24"></i>`+
                             `<div class="d-flex flex-column ms-12">`+
                               `<span class="text-dark fs-12 fw-600 lh-16">Recipient Name</span>`+
                               `<span class="text-dark fs-14 lh-20">${nameUser}</span>`+
                             `</div>`+
                             `<div class="d-flex align-items-center text-info ms-auto">`+
                               `<span class="fs-12 fw-600">Edit</span>`+
                               `<i class="ri-arrow-right-s-line fs-18 "></i>`+
                             `</div>`;

    $(`.recipientName-${id}`).html(bodyrecipientName);
    $(`#formRecipientName-${id}`).val(nameUser);
  }

  function recipientNote(remark, id) {
    var bodyrecipientNote = `<i class="ri-sticky-note-line text-neutral-80 fs-24"></i>`+
                            `<div class="d-flex flex-column ms-12">`+
                              `<span class="text-dark fs-12 fw-600 lh-16">Remark</span>`+
                              `<span class="text-dark fs-14 lh-20">${remark}</span>`+
                            `</div>`+
                            `<div class="d-flex align-items-center text-info ms-auto">`+
                              `<span class="fs-12 fw-600">Edit</span>`+
                              `<i class="ri-arrow-right-s-line fs-18"></i>`+
                            `</div>`;

    $(`.recipientNote-${id}`).html(bodyrecipientNote);
    $(`#formRecipientNote-${id}`).val(remark);
  }
})